module.exports = __webpack_public_path__ + "img/refund-type-tui.6e110d74.png";